var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_vm._l((_vm.legallinks),function(link){return _c('div',{key:link.ID,staticClass:"link-container"},[_c('a',{staticClass:"link",attrs:{"href":link.Link,"target":"_blank"}},[_vm._v(_vm._s(link.Name))])])}),_c('LanguageChanger')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }